// dependencies
import * as Sentry from "@sentry/react";
import { CreateProcess } from "redux-process";

// utils
import serializeObject from "../../utils/SerializeObject";

export const getReportAnalyticsInfo = CreateProcess({
	method: "GET",
	name: "GetReportAnalyticsInfo",
	type: "REPORTANALYTICS:GETINFO",

	request: (props) => {
		const queryParams = serializeObject(props.queryParams);
		return {
			url: `/api/analytics-reports/?${queryParams}`,
		};
	},

	success: (response) => {
		const { data } = response;

		try {
			return data;
		} catch (ermahgerd) {
			Sentry.captureException(ermahgerd);
			return [];
		}
	},
});

export const deleteReportAnalytics = CreateProcess({
	method: "DELETE",
	name: "DeleteReportAnalytics",
	type: "REPORTANALYTICS:DELETE",

	request: (props) => {
		const queryParams = serializeObject(props);
		return {
			url: `/api/analytics-reports/?${queryParams}`,
		};
	},

	success: (response) => {
		const { data } = response;
		try {
			return data;
		} catch (ermahgerd) {
			Sentry.captureException(ermahgerd);
			return [];
		}
	},
});

export const saveNewReportAnalytics = CreateProcess({
	method: "POST",
	name: "SaveNewReportAnalytics",
	type: "REPORTANALYTICS:POST",

	request: (props) => ({
		url: "/api/analytics-reports",
		payload: props.payload,
	}),

	success: (response) => {
		const { data } = response;

		try {
			return data;
		} catch (ermahgerd) {
			Sentry.captureException(ermahgerd);
			return [];
		}
	},
});
